import { Badge, FormField, Link, Popover, Table } from '@cloudscape-design/components';
import { mdiHumanMaleBoard, mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { ItemBooking } from '../../resources/types';


interface TableBookingsFlatProps {
    visible: boolean;
    showDate?: boolean;
    bookings: ItemBooking[];
    onBookingClick?: (book: ItemBooking) => void;
}

const TableBookingsFlat: React.FC<TableBookingsFlatProps> = ({
    visible,
    bookings,
    showDate = false,
    onBookingClick
}) => {

    // Flatten: insert parent row, then all children



    return (
        <Table
            variant="embedded"
            stripedRows
            stickyHeader
            columnDefinitions={[
                {
                    id: 'idBooking',
                    header: 'Equipo',
                    cell: (item) => (
                        <FormField
                            description={item.bookingType}
                            label={!!onBookingClick ? <Link onClick={() => {
                                onBookingClick(item);
                            }}>{item.registration}</Link> : item.registration}
                        />
                    )
                },
                {
                    id: 'displayName',
                    header: 'Usuario',
                    cell: (item) => (
                        <FormField
                            description={
                                item.instructor ? (
                                    <>
                                        <Icon path={mdiHumanMaleBoard} size={1} /> {item.instructor}
                                    </>
                                ) : null
                            }
                            label={
                                item.obsBooking === "" ? item.displayName :
                                    <>
                                        {item.displayName}

                                        <Popover


                                            dismissButton={false}
                                            position="top"
                                            size="small"
                                            triggerType="custom"
                                            content={
                                                item?.obsBooking
                                            }
                                        >
                                            {" "}<Icon path={mdiInformation} size={0.75} />
                                        </Popover>
                                    </>
                            }
                        />)
                },
                {
                    id: 'time',
                    header: 'Horario',
                    cell: (item) =>
                        !showDate ? `${item.timeStart} - ${item.timeEnd}` : (
                            <>
                                <FormField label={`${item.timeStart} - ${item.timeEnd}`}>
                                    {item.dateStart}
                                </FormField>
                            </>
                        )
                },
                {
                    id: 'bookingType',
                    header: 'Tipo',
                    cell: (item) => {

                        const towTypeLabel = {
                            MOUNTAIN: <Badge color="severity-high">Cordillera</Badge>,
                            SANRAMON: <Badge color="severity-medium">San Ramón</Badge>,
                            LOCAL: <Badge color="severity-neutral">Local</Badge>,
                            NONE: ' ',
                            BALLAST: <Badge color="green">Lastre</Badge>
                        }[item.towType] || item.towType;

                        return (
                            <FormField
                                description={towTypeLabel}
                                label={item.bookingType}
                            />
                        );
                    }
                }
            ]}
            items={bookings}
            trackBy={(item) => String(item.idBooking)}
        />
    );
};

export default TableBookingsFlat;




